import { Component, Input } from '@angular/core';

import { Tabs } from './tabbing.interface';
import { TaggingService } from '@dcsg-ngx-ecommerce/engage/service/tagging.service';
import { UtilityService } from '@dcsg-ngx-ecommerce/core';

@Component({
	selector: 'home-tabbing',
	templateUrl: './tabbing.component.html',
	styleUrls: ['./tabbing.component.scss']
})
export class TabbingComponent {
	@Input() data: Tabs[];
	@Input() addlData: any;

	public altTagService: any;
	public targetService: any;

	constructor(private taggingService: TaggingService, private utilityService: UtilityService) {
		this.altTagService = taggingService.altTag;
		this.targetService = this.utilityService.target;
	}

	createTag(tabIndex: number, contentIndex: number, link: string, altText: string) {
		return this.taggingService.createTag(this.addlData.tagSectionNum, this.addlData.widgetTypeTag, tabIndex, contentIndex, link, altText);
	}

}
